import React from 'react';
import PropTypes from 'prop-types';
import { Markup } from 'interweave';
import I18n from 'utils/I18n';

import styles from '../index.scss';
import { powerAndSegmentGoalAchievementsProps } from '../../../../props/feed-prop-types';

const PowerAndSegmentGoalAchievements = ({
  powerAndSegmentGoalAchievements,
  activityId
}) => (
  <>
    {powerAndSegmentGoalAchievements.length > 0 && (
      <li data-testid="power_and_segment_goals">
        <a
          href={powerAndSegmentGoalAchievements[0].url}
          className={styles.achievementsLink}
          data-testid="power_and_segment_goals_description"
        >
          {powerAndSegmentGoalAchievements[0].description}
        </a>
        {powerAndSegmentGoalAchievements.length > 1 && (
          <div
            className={styles.powerAndSegmentGoalAchievementsMore}
            data-testid="power_and_segment_goals_more"
          >
            <Markup
              noWrap={true}
              content={I18n.t(
                'components.feed.performance_goal_completed.and_x_more_html',
                {
                  more_goals_link: `/activities/${activityId}`,
                  count: powerAndSegmentGoalAchievements.length - 1
                }
              )}
            />
          </div>
        )}
      </li>
    )}
  </>
);

PowerAndSegmentGoalAchievements.propTypes = {
  powerAndSegmentGoalAchievements: powerAndSegmentGoalAchievementsProps,
  activityId: PropTypes.string.isRequired
};

PowerAndSegmentGoalAchievements.defaultProps = {
  powerAndSegmentGoalAchievements: []
};

export default PowerAndSegmentGoalAchievements;
